import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "@sitemule/ng-components/components/button";
import { WebBasedServiceComponent } from "./web-based-service.component";

@NgModule({
  declarations: [
    WebBasedServiceComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
  ],
  exports:[WebBasedServiceComponent],
  providers: [],
  bootstrap: [],
})
export class WebBasedServiceModule {}
